import React from 'react';
import { Button, Flex, Popover, Switch, Text } from 'core/components';
import { SESSION_FEATURES } from '@kentik/ui-shared/kaizen/constants';
import { FiSliders } from 'react-icons/fi';

const SessionFeatureIndicator = ({ activeFeatures }) => {
  if (!Array.isArray(activeFeatures) || activeFeatures.length === 0) {
    return null;
  }

  const featureMetadata = SESSION_FEATURES.filter((f) => activeFeatures.includes(f.key));

  if (featureMetadata.length === 0) {
    return null;
  }

  return (
    <Popover
      position="bottom-right"
      content={
        <Flex flexDirection="column" p={2} gap={2} minWidth={250}>
          <Text fontWeight="bold">Session Features</Text>
          {featureMetadata.map((feature) => (
            <Flex key={feature.key} justifyContent="space-between" alignItems="center" gap={1}>
              <Switch checked disabled />
              <Flex flexDirection="column" gap="2px">
                <Text>{feature.label}</Text>
                <Text small muted>
                  {feature.description}
                </Text>
              </Flex>
            </Flex>
          ))}
        </Flex>
      }
    >
      <Button minimal icon={FiSliders} intent="success" title="Active session features">
        <Text>Features ({featureMetadata.length})</Text>
      </Button>
    </Popover>
  );
};

export default SessionFeatureIndicator;
